<template>
  <div class="content-page" v-if="applitInfo && auditStatus">
    <div class="bd">
      <div class="content">
        <div class="block-title">
          <div class="inner">版本信息</div>
        </div>
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="180px">
            <el-form-item v-if="auditStatus.status != -1" label="模板名称：">
              <div class="inside-content">
                <span>{{ applitInfo.templateName }}</span>
              </div>
            </el-form-item>
            <el-form-item label="版本号：">
              <div class="inside-content">
                <span v-if="auditStatus.status != -1">
                  {{ applitInfo.templateVersion }}
                </span>
                <span v-else>你的小程序尚未发布，请执行发布操作</span>
              </div>
            </el-form-item>
            <el-form-item v-if="auditStatus.status != -1" label="更新时间：">
              <div class="inside-content">
                <span>{{ applitInfo.modifyTime }}</span>
              </div>
            </el-form-item>
            <el-form-item label="更新状态：" v-if="auditStatus.status != -1">
              <div class="inside-content">
                <span class="text-success" v-if="auditStatus.status == 0">审核通过</span>
                <span class="text-danger" v-if="auditStatus.status == 1">审核失败</span>
                <span v-if="auditStatus.status == 2">审核中</span>
                <span class="text-warning" v-if="auditStatus.status == 3">已撤回</span>
                <span class="text-success" v-if="auditStatus.status == 4">已发布</span>
                <span class="text-primary" v-if="auditStatus.status == 5">已上传</span>
              </div>
            </el-form-item>
            <el-form-item v-if="auditStatus.status == 1" label="失败原因：">
              <div class="inside-content">
                <span v-html="auditStatus.reason"></span>
              </div>
            </el-form-item>
            <el-form-item
              v-if="
                auditStatus.status == 5 ||
                auditStatus.status == 3 ||
                auditStatus.status == 1
              "
            >
              <div class="inside-content">
                <el-button type="primary" size="mini" @click="submitAudit"
                  >提交审核</el-button
                >
              </div>
            </el-form-item>
            <el-form-item v-if="auditStatus.status == -1">
              <div class="inside-content">
                <el-button type="primary" size="mini" @click="linkTo('/applt/template')"
                  >选择模板</el-button
                >
              </div>
            </el-form-item>
            <el-form-item v-if="auditStatus.status == 0">
              <div class="inside-content">
                <el-button
                  type="primary"
                  size="mini"
                  v-loading="appltReleaseLoading"
                  @click="miniAppProduceRelease"
                  >发布小程序</el-button
                >
              </div>
            </el-form-item>
            <el-form-item v-if="auditStatus.status == 2">
              <div class="inside-content">
                <el-button type="danger" size="mini" @click="undocodeaudit"
                  >撤回审核</el-button
                >
              </div>
            </el-form-item>
            <el-form-item v-if="appltType == 'dy' && !merchantStatusDY">
              <div class="inside-content">
                <el-button type="primary" size="mini" @click="openMerchantStatusDYURL"
                  >支付进件</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              v-if="
                appltType == 'dy' &&
                merchantStatusDY &&
                applitInfo &&
                !applitInfo.payToken
              "
            >
              <div class="inside-content">
                <el-button
                  type="primary"
                  size="mini"
                  @click="isShowMerchantInfoPopup = true"
                  >提交进件信息</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content">
        <div class="block-title">
          <div class="inner">
            基本信息
            <el-button
              type="primary"
              size="mini"
              style="margin-left: 20px"
              plain
              @click="updateMiniAppInfo"
              >刷新</el-button
            >
          </div>
        </div>
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="180px">
            <el-form-item label="小程序名称：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <span v-if="appltType == 'wx' || appltType == 'IOTAPP'">{{
                    applitInfo.nickName
                  }}</span>
                  <el-button
                    v-if="appltType == 'wx'"
                    type="primary"
                    size="small"
                    class="applt-set-button"
                    @click="appltSet('wxNic')"
                    >设置</el-button
                  >
                  <span class="tips" v-if="appltType == 'wx'"
                    >（可修改2次，修改后一段时候生效，请勿多次提交）</span
                  >
                  <el-input
                    v-else-if="appltType == 'TINYAPP' || appltType == 'dy'"
                    v-model="applitInfo.nickName"
                    placeholder="请输入小程序名称"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序英文名称：" v-if="appltType == 'TINYAPP'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-input
                    v-model="applitInfo.englishName"
                    placeholder="请输入小程序英文名称"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序头像：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <img
                    class="avatar"
                    v-if="appltType == 'wx' || appltType == 'IOTAPP'"
                    src="http://oss-cn-shanghai-shga-d01-a.ops.ga.sh/shga-ryzp/CSJ/ZHEJIANG_CZRK_ZP/36603531_330302.jpg"
                    alt
                  />
                  <el-button
                    v-if="appltType == 'wx'"
                    type="primary"
                    size="small"
                    class="applt-set-button"
                    @click="appltSet('wxHImg')"
                    >设置</el-button
                  >
                  <span class="tips" v-if="appltType == 'wx'"
                    >（每年修改5次，修改头像后4小时左右才生效，请勿多次提交）</span
                  >
                  <el-upload
                    v-else-if="appltType == 'TINYAPP' || appltType == 'dy'"
                    :multiple="true"
                    action="/YmUpload_image"
                    list-type="picture-card"
                    :on-remove="handleRemoveImg"
                    :before-upload="beforeImgUplod"
                    :http-request="handleSuccessImg"
                    :file-list="headImg"
                    accept=".JPG,.png,.GIF"
                    :limit="1"
                    :class="{
                      hide: headImg.length,
                    }"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="介绍：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <span v-if="appltType == 'wx' || appltType == 'IOTAPP'">
                    {{ applitInfo.signature }}
                  </span>
                  <el-button
                    v-if="appltType == 'wx'"
                    type="primary"
                    size="small"
                    class="applt-set-button"
                    @click="appltSet('wxSignature')"
                    >设置</el-button
                  >
                  <span class="tips" v-if="appltType == 'wx'"
                    >（一个月内可申请5次修改，修改后一段时候生效，请勿多次提交）</span
                  >
                  <el-input
                    v-else-if="appltType == 'TINYAPP' || appltType == 'dy'"
                    type="textarea"
                    v-model="applitInfo.signature"
                    placeholder="请输入小程序介绍"
                    size="small"
                    :rows="2"
                    maxlength="32"
                    show-word-limit
                    clearable
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="应用描述：" v-if="appltType == 'TINYAPP'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-input
                    type="textarea"
                    :rows="3"
                    minlength="20"
                    maxlength="200"
                    show-word-limit
                    clearable
                    v-model="applitInfo.appDesc"
                    placeholder="请输入应用描述"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="客服电话：" v-if="appltType == 'TINYAPP'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-input
                    v-model="applitInfo.servicePhone"
                    placeholder="请输入客服电话"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="客服邮箱：" v-if="appltType == 'TINYAPP'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-input
                    v-model="applitInfo.serviceEmail"
                    placeholder="请输入客服邮箱"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="主营类目：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <template v-if="appltType == 'wx'">
                    <div v-for="(item, index) in applitInfo.categories" :key="index">
                      {{ item.first }} &gt; {{ item.second }}
                    </div>
                  </template>
                  <template v-else-if="appltType == 'dy'">
                    <div v-for="(item, index) in applitInfo.categories" :key="index">
                      {{ item.app_category_name }}
                    </div>
                  </template>
                  <template v-else>
                    {{
                      typeof applitInfo.categories == "string" &&
                      applitInfo.categories.split(";")[0]
                    }}
                  </template>
                  <span class="tips" v-if="appltType == 'wx'"
                    >（一个月内可申请5次修改，修改后一段时候生效，请勿多次提交）</span
                  >
                  <el-button
                    v-if="appltType == 'wx' && applitInfo.categories.length < 5"
                    type="primary"
                    size="small"
                    class="applt-set-button"
                    @click="appltSet('wxCategories')"
                    >添加</el-button
                  >
                  <el-button
                    v-else-if="appltType == 'dy'"
                    type="primary"
                    size="small"
                    class="applt-set-button"
                    @click="appltSet('dyCategories')"
                    >设置</el-button
                  >
                  <el-button
                    v-else
                    type="primary"
                    size="small"
                    class="applt-set-button"
                    @click="appltSet('aliCategories')"
                    >设置</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="辅营类目：" v-if="appltType == 'TINYAPP'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <template>
                    {{
                      typeof applitInfo.categories == "string" &&
                      applitInfo.categories.split(";")[1]
                    }}
                  </template>
                  <el-button
                    type="primary"
                    size="small"
                    class="applt-set-button"
                    @click="appltSet('aliViceCategories')"
                    >设置</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="主体信息：" v-show="appltType == 'wx'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <p>{{ applitInfo.principalName }}</p>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序认证：" v-show="appltType == 'wx'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <p>
                    {{ applitInfo.verifyTypeInfo == -1 ? "未认证" : "微信认证" }}
                  </p>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-show="appltType == 'TINYAPP'">
              <el-button type="primary" @click="appltSettingSave('aliCategories')"
                >保存</el-button
              >
            </el-form-item>
            <el-form-item v-show="appltType == 'dy'">
              <el-button type="primary" @click="appltSettingSave('dyAppltInfo')"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content">
        <div class="block-title">
          <div class="inner">账号信息</div>
        </div>
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="180px">
            <el-form-item label="小程序AppID：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <span>{{ applitInfo.authorizerAppId }}</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="原始ID ：" v-show="appltType == 'wx'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <span>{{ applitInfo.originalId }}</span>
                </div>
              </div>
            </el-form-item>
            <!-- <el-form-item label="开放平台帐号ID：" v-show="appltType == 'wx'">
              <div class="form-inline-content">
                <div class="inside-content">
                  <span></span>
                </div>
              </div>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
      <div class="content">
        <div class="block-title">
          <div class="inner">二维码</div>
        </div>
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="180px">
            <el-form-item label="体验二维码：" v-if="applitInfo.experienceQrcodeUrl">
              <div class="form-inline-content">
                <div class="inside-content">
                  <!-- <qrcode
                    :value="applitInfo.experienceQrcodeUrl"
                    :options="{ size: 100 }"
                    class="scan-code-img"
                  ></qrcode>-->
                  <img
                    :src="applitInfo.experienceQrcodeUrl"
                    class="scan-code-img"
                    alt
                    srcset
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="小程序码：" v-if="applitInfo.qrcodeUrl">
              <div class="form-inline-content flex">
                <div class="inside-content center">
                  <img
                    :src="applitInfo.qrcodeUrl"
                    class="scan-code-img"
                    id="qrcodeUrl"
                    alt
                    srcset
                  />
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      @click="downQrcodeUrl(applitInfo.qrcodeUrl)"
                      >下载小程序码</el-button
                    >
                  </div>
                </div>
                <!-- <div class="inside-content center">
                  <qrcode
                    v-if="publishQrCode"
                    :value="publishQrCode"
                    :options="{ size: 500 }"
                    class="scan-code-img"
                    id="paycode"
                  ></qrcode>
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      v-if="!publishQrCode"
                      @click="addPublishQrCodeJump"
                      >生成二维码</el-button
                    >
                  </div>
                </div> -->
              </div>
            </el-form-item>
            <el-form-item label="收款码：" v-if="applitInfo.state == 4">
              <div class="form-inline-content flex">
                <div class="inside-content center">
                  <!-- <qrcode
                    :value="QueryDetail"
                    :options="{ size: 500 }"
                    class="scan-code-img"
                    id="paycode"
                  ></qrcode> -->
                  <img
                    :src="QueryDetail || applitInfo.payUrl"
                    class="scan-code-img"
                    id="qrcodeUrl"
                    alt
                    srcset
                  />
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      v-if="!(QueryDetail || applitInfo.payUrl)"
                      @click="getPayCode"
                      >生成收款码</el-button
                    >
                    <el-button
                      type="primary"
                      size="small"
                      @click="downQrcodeUrl(QueryDetail || applitInfo.payUrl)"
                      v-else
                      >下载收款码</el-button
                    >
                  </div>
                </div>
                <!-- <div class="inside-content center">
                  <qrcode
                    v-if="publishPayQrCode"
                    :value="publishPayQrCode"
                    :options="{ size: 500 }"
                    class="scan-code-img"
                    id="paycode"
                  ></qrcode>
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      v-if="!publishPayQrCode"
                      @click="addPublishQrCodeJump"
                      >生成二维码</el-button
                    >
                  </div>
                </div> -->
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="content" v-if="appltType != 'dy'">
        <div class="block-title">
          <div class="inner">小程序操作</div>
        </div>
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="160px">
            <el-form-item label="订阅消息：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-tag
                    v-for="item in onOfMessageList"
                    :key="item.id"
                    closable
                    :disable-transitions="false"
                    @click="appltType == 'wx' ? '' : editSubMsg(item, 'modify')"
                    @close="deleteSubMsg(item.id)"
                  >
                    {{ item.templateName }}
                  </el-tag>
                  <!-- <el-button
                    v-for="item in onOfMessageList"
                    size="small"
                    :key="item.id"
                    type="success"
                    plain
                    :disabled="appltType == 'wx'"
                    @click="editSubMsg(item, 'modify')"
                    >{{ item.templateName }}</el-button
                  > -->
                  <el-button type="primary" size="small" @click="dialogVisible = true"
                    >添加</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <!-- <el-form-item label="是否带直播：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-switch v-model="switchLive" @change="liveChange"></el-switch>
                  <el-link
                    style="margin-left: 10px"
                    :underline="false"
                    :href="
                      appltType == 'wx'
                        ? 'https://developers.weixin.qq.com/community/develop/doc/0008ce654c4450244c1a7e5de5b801?highLine=%25E5%25B0%258F%25E7%25A8%258B%25E5%25BA%258F%25E5%25BC%2580%25E9%2580%259A%25E7%259B%25B4%25E6%2592%25AD'
                        : 'https://opendocs.alipay.com/mini/01ejie'
                    "
                    type="primary"
                    target="_blank"
                    >直播开通</el-link
                  >
                </div>
              </div>
            </el-form-item> -->
            <el-form-item label="客服">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-link
                    style="margin-left: 10px"
                    :underline="false"
                    :href="
                      appltType == 'wx'
                        ? 'https://developers.weixin.qq.com/miniprogram/introduction/custom.html#%E7%BD%91%E9%A1%B5%E7%89%88%E5%AE%A2%E6%9C%8D%E5%B7%A5%E5%85%B7%E4%B8%8E%E7%A7%BB%E5%8A%A8%E7%AB%AF%E5%B0%8F%E7%A8%8B%E5%BA%8F%E5%AE%A2%E6%9C%8D%E5%B7%A5%E5%85%B7'
                        : 'https://opendocs.alipay.com/mini/operation/custom-service#%E5%BC%80%E9%80%9A%E6%99%BA%E8%83%BD%E5%AE%A2%E6%9C%8D%E8%83%BD%E5%8A%9B'
                    "
                    type="primary"
                    target="_blank"
                    >客服操作</el-link
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="外部链接">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-switch
                    class="custom"
                    disabled
                    v-model="openLink"
                    @click.native="openLinkChange"
                  ></el-switch>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="聚合码开关">
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-switch
                    class="custom"
                    disabled
                    v-model="isBindQrCode"
                    @click.native="addBindQrCode"
                  ></el-switch>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="申请接口(获取当前的地理位置、速度)"
              v-show="appltType == 'wx'"
            >
              <div class="form-inline-content">
                <div class="inside-content">
                  <p
                    class="status"
                    :class="{
                      ing: wxGetLocationStatus == 3,
                      suc: wxGetLocationStatus == 5,
                      fail: wxGetLocationStatus == 4,
                    }"
                    v-if="
                      wxGetLocationStatus == 3 ||
                      wxGetLocationStatus == 4 ||
                      wxGetLocationStatus == 5
                    "
                  >
                    {{ stausObj[wxGetLocationStatus] }}
                    <span v-if="wxGetLocationFailReason"
                      >（失败原因：{{ wxGetLocationFailReason }}）</span
                    >
                  </p>
                  <el-button
                    v-if="
                      wxGetLocationStatus == 1 ||
                      wxGetLocationStatus == 2 ||
                      wxGetLocationStatus == 4
                    "
                    type="primary"
                    size="small"
                    @click="applyPrivacy('wx.getLocation')"
                    >申请</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="申请接口(监听实时地理位置变化事件)"
              v-show="appltType == 'wx'"
            >
              <div class="form-inline-content">
                <div class="inside-content">
                  <p
                    class="status"
                    :class="{
                      ing: wxOnLocationChangeStatus == 3,
                      suc: wxOnLocationChangeStatus == 5,
                      fail: wxOnLocationChangeStatus == 4,
                    }"
                    v-if="
                      wxOnLocationChangeStatus == 3 ||
                      wxOnLocationChangeStatus == 4 ||
                      wxOnLocationChangeStatus == 5
                    "
                  >
                    {{ stausObj[wxOnLocationChangeStatus] }}
                    <span v-if="wxOnLocationChangeFailReason"
                      >（失败原因：{{ wxOnLocationChangeFailReason }}）</span
                    >
                  </p>
                  <el-button
                    v-if="
                      wxOnLocationChangeStatus == 1 ||
                      wxOnLocationChangeStatus == 2 ||
                      wxOnLocationChangeStatus == 4
                    "
                    type="primary"
                    size="small"
                    @click="applyPrivacy('wx.onLocationChange')"
                    >申请</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="体验者：">
              <div class="form-inline-content">
                <div class="inside-content" v-show="appltType == 'wx'">
                  <el-input
                    v-model="weixinString"
                    placeholder="请输入体验微信号"
                  ></el-input>
                  <el-button type="primary" @click="bindtester">添加</el-button>
                  <el-button type="danger" @click="unbindtester">解绑</el-button>
                </div>
                <div
                  class="inside-content"
                  v-show="appltType == 'TINYAPP' || appltType == 'IOTAPP'"
                >
                  <div>
                    <el-input
                      v-model="weixinString"
                      placeholder="请输入体验支付宝账号"
                    ></el-input>
                    <el-button type="primary" @click="bindtester">添加</el-button>
                  </div>
                  <div style="margin-top: 5px">
                    <el-select
                      v-model="selAlipayAccount"
                      placeholder="请选择需解绑支付宝账号"
                    >
                      <el-option
                        v-for="(item, index) in alipayAccountList"
                        :key="index"
                        :label="item.nickName"
                        :value="item.userId"
                      ></el-option>
                    </el-select>
                    <el-button type="danger" @click="unbindtester">解绑</el-button>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="40%">
      <span v-if="appltType == 'wx'">
        <el-radio-group v-model="checkedMessage">
          <el-radio
            v-for="item in messageList"
            :label="item.id"
            :key="item.id"
            border
            style="margin-top: 10px"
            >{{ item.templateName }}</el-radio
          >
        </el-radio-group>
      </span>
      <span v-else>
        <el-button
          v-for="item in messageList"
          size="small"
          :key="item.id"
          type="success"
          plain
          :disabled="appltType == 'wx'"
          @click="editSubMsg(item)"
          >{{ item.templateName }}</el-button
        >
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="appltType == 'wx'"
          type="primary"
          @click="modifyMiniAppSubscribeMessage"
          :disabled="!checkedMessage"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div
      class="popup submsg"
      :class="{
        show: aliSubMsgPop,
      }"
      style="z-index: 9999"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>订阅消息</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="aliSubMsgPop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            :model="aliSubMsgForm"
            :rules="aliSubMsgRules"
            ref="aliSubMsgForm"
            label-width="128px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="模板名称" prop="templateName">
              <el-input
                type="text"
                placeholder="请输入模板名称"
                v-model="aliSubMsgForm.templateName"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="模板编号" prop="templateNo">
              <el-input
                type="text"
                placeholder="请输入模板编号"
                v-model="aliSubMsgForm.templateNo"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="模板字段" prop="templateItem">
              <el-input
                type="text"
                placeholder="请输入模板字段"
                v-model="aliSubMsgForm.templateItem"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="外部平台模板id" prop="templateId" v-if="!isOwn">
              <el-input
                type="text"
                placeholder="请输入外部平台模板id"
                v-model="aliSubMsgForm.templateId"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="tips" v-if="!isOwn">
            <p>第一步：订购&引入消息订阅插件</p>
            <p>第二步：选用&添加消息模板</p>
            <p>第三步：配置外部平台模板id</p>
            <p>
              <el-link
                :underline="false"
                href="https://opendocs.alipay.com/mini/01rnqx"
                type="primary"
                target="_blank"
                >查看详细文档</el-link
              >
            </p>
          </div>
          <el-button type="primary" @click="submitForm('aliSubMsgForm')">提交</el-button>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowNicSetting,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>名称设置</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowNicSetting = false"
          />
        </div>
        <div class="popup-container">
          <el-input
            v-model="wxNickName"
            placeholder="请输入小程序名称"
            size="small"
          ></el-input>
          <div class="action">
            <el-button type="primary" size="small" @click="appltSettingSave('wxNicSave')"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowHImgSetting,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>头像设置</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowHImgSetting = false"
          />
        </div>
        <div class="popup-container head-img">
          <el-upload
            :multiple="true"
            action="/YmUpload_image"
            list-type="picture-card"
            :on-remove="handleRemoveImg"
            :before-upload="beforeImgUplod"
            :http-request="handleSuccessImg"
            :file-list="headImg"
            accept=".JPG,.png,.GIF"
            :limit="1"
            :class="{
              hide: headImg.length,
            }"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="action">
            <el-button type="primary" size="small" @click="appltSettingSave('wxHImg')"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowSignatureSetting,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>帐号介绍</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowSignatureSetting = false"
          />
        </div>
        <div class="popup-container">
          <el-input
            v-model="signature"
            placeholder="请输入小程序介绍"
            size="small"
          ></el-input>
          <div class="action">
            <el-button
              type="primary"
              size="small"
              @click="appltSettingSave('wxSignatureSave')"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup cate"
      :class="{
        show: isShowWxCategoriesSetting,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>类目修改</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowWxCategoriesSetting = false"
          />
        </div>
        <div class="popup-container">
          <el-form
            :model="wxCategoriesForm"
            :rules="wxCategoriesRules"
            ref="wxCategoriesForm"
            label-width="208px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="一级类目选择" prop="first">
              <el-select v-model="wxFCate" placeholder="请选择一级类目">
                <el-option
                  v-for="(item, index) in wxCategoriesList"
                  :key="item.id"
                  :label="item.name"
                  :value="index"
                  v-if="item.name && item.father == 0"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="wxFCate !== '' && wxCategoriesList[wxFCate].children.length"
              label="二级类目选择"
              prop="second"
            >
              <el-select v-model="wxSCate" placeholder="请选择二级类目">
                <el-option
                  v-for="(item, index) in wxCategoriesList"
                  :key="item.id"
                  :label="item.name"
                  :value="index"
                  v-if="item.name && item.father == wxCategoriesList[wxFCate].id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-for="item in wxCategoriesForm.certicates"
              :label="item.key"
              prop="first"
              :key="item.key"
            >
              <el-upload
                :multiple="true"
                action="/YmUpload_image"
                list-type="picture-card"
                :data="{
                  key: item.key,
                }"
                :on-remove="handleRemoveCerticates"
                :before-upload="beforeImgUplod"
                :http-request="handleSuccessCerticates"
                :file-list="item.value"
                accept=".JPG,.png,.GIF"
                :limit="1"
                :class="{
                  hide: item.value.length,
                }"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div class="action">
            <el-button
              type="primary"
              size="small"
              @click="appltSettingSave('wxCategories')"
              >添加</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup cate"
      :class="{
        show: isShowAliCategoriesSetting,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>{{ aliCateType == "just" ? "主营类目" : "辅营类目" }}设置</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowAliCategoriesSetting = false"
          />
        </div>
        <div class="popup-container">
          <el-form
            :model="aliCategoriesForm"
            :rules="aliCategoriesRules"
            ref="aliCategoriesForm"
            label-width="208px"
            :hide-required-asterisk="true"
            status-icon
          >
            <template v-if="aliCateType == 'just'">
              <el-form-item label="一级类目选择" prop="categories">
                <el-select v-model="aliFCate" placeholder="请选择一级类目">
                  <el-option
                    v-for="(item, index) in aliCategoryList"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="index"
                    v-if="item.categoryName && item.parentCategoryId == 0"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="aliFCate !== '' && aliCategoryList[aliFCate].hasChild"
                label="二级类目选择"
                prop="categories"
              >
                <el-select v-model="aliSCate" placeholder="请选择二级类目">
                  <el-option
                    v-for="(item, index) in aliCategoryList"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="index"
                    v-if="
                      item.categoryName &&
                      item.parentCategoryId == aliCategoryList[aliFCate].categoryId
                    "
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="aliSCate && aliCategoryList[aliSCate].hasChild"
                label="三级类目选择"
                prop="categories"
              >
                <el-select v-model="aliTCate" placeholder="请选择三级类目">
                  <el-option
                    v-for="(item, index) in aliCategoryList"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="index"
                    v-if="
                      item.categoryName &&
                      item.parentCategoryId == aliCategoryList[aliSCate].categoryId
                    "
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-if="aliCateType == 'vice'">
              <el-form-item label="一级类目选择" prop="viceCategories">
                <el-select v-model="aliViceFCate" placeholder="请选择一级类目">
                  <el-option
                    v-for="(item, index) in aliCategoryList"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="index"
                    v-if="item.categoryName && item.parentCategoryId == 0"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="aliViceFCate !== '' && aliCategoryList[aliViceFCate].hasChild"
                label="二级类目选择"
                prop="viceCategories"
              >
                <el-select v-model="aliViceSCate" placeholder="请选择二级类目">
                  <el-option
                    v-for="(item, index) in aliCategoryList"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="index"
                    v-if="
                      item.categoryName &&
                      item.parentCategoryId == aliCategoryList[aliViceFCate].categoryId
                    "
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="aliViceSCate && aliCategoryList[aliViceSCate].hasChild"
                label="三级类目选择"
                prop="viceCategories"
              >
                <el-select v-model="aliViceTCate" placeholder="请选择三级类目">
                  <el-option
                    v-for="(item, index) in aliCategoryList"
                    :key="item.categoryId"
                    :label="item.categoryName"
                    :value="index"
                    v-if="
                      item.categoryName &&
                      item.parentCategoryId == aliCategoryList[aliViceSCate].categoryId
                    "
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item
              label="门头照"
              prop="outDoorPic"
              v-if="aliCategoriesForm.needOutDoorPic"
            >
              <el-upload
                :multiple="true"
                action="/YmUpload_image"
                list-type="picture-card"
                :data="{
                  key: 'outDoorPic',
                }"
                :on-remove="handleRemoveCerticatesAli"
                :before-upload="beforeImgUplod"
                :http-request="handleSuccessCerticatesAli"
                :file-list="outDoorPic"
                accept=".JPG,.png,.GIF"
                :limit="1"
                :class="{
                  hide: outDoorPic.length,
                }"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="企业名称："
              prop="businessName"
              v-if="aliCategoriesForm.needOutDoorPic"
            >
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-input
                    v-model="aliCategoriesForm.businessName"
                    placeholder="请输入企业名称"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="注册号："
              prop="businessRegistNumber"
              v-if="aliCategoriesForm.needLicense"
            >
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-input
                    v-model="aliCategoriesForm.businessRegistNumber"
                    placeholder="请输入注册号"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="营业执照图片(最多5张)"
              prop="licensePics"
              v-if="aliCategoriesForm.needLicense"
            >
              <el-upload
                :multiple="true"
                action="/YmUpload_image"
                list-type="picture-card"
                :data="{
                  key: 'licensePics',
                }"
                :on-remove="handleRemoveCerticatesAli"
                :before-upload="beforeImgUplod"
                :http-request="handleSuccessCerticatesAli"
                :file-list="licensePics"
                accept=".JPG,.png,.GIF"
                :limit="5"
                :class="{
                  hide: licensePics.length >= 5,
                }"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="营业执照到期时间："
              prop="licenseValidDate"
              v-if="aliCategoriesForm.needLicense"
            >
              <div class="form-inline-content">
                <div class="inside-content">
                  <el-input
                    v-model="aliCategoriesForm.licenseValidDate"
                    placeholder="请输入营业执照到期时间"
                    size="small"
                  ></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="特殊资质图片(最多3张)"
              prop="specialLicensePics"
              v-if="aliCategoriesForm.needSpecialLicense"
            >
              <el-upload
                :multiple="true"
                action="/YmUpload_image"
                list-type="picture-card"
                :data="{
                  key: 'specialLicensePics',
                }"
                :on-remove="handleRemoveCerticatesAli"
                :before-upload="beforeImgUplod"
                :http-request="handleSuccessCerticatesAli"
                :file-list="specialLicensePics"
                accept=".JPG,.png,.GIF"
                :limit="3"
                :class="{
                  hide: specialLicensePics.length >= 3,
                }"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div class="action">
            <el-button
              type="primary"
              size="small"
              @click="appltSettingSave('aliCategories')"
              >添加</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup cate dy"
      :class="{
        show: isShowDYCategoriesSetting,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>类目修改</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowDYCategoriesSetting = false"
          />
        </div>
        <div class="popup-container">
          <el-form label-width="268px" :hide-required-asterisk="true" status-icon>
            <el-form-item label="类目选择">
              <el-cascader
                v-model="dyCategory"
                :options="dyCategoryList"
                :props="{ expandTrigger: 'hover' }"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              v-for="item in dyCategoryCertification"
              :label="item.key"
              prop="first"
              :key="item.key"
            >
              <p class="text-red">
                {{ item.tipsText }}
              </p>
              <el-upload
                :multiple="true"
                action="/YmUpload_image"
                list-type="picture-card"
                :data="{
                  key: item.key,
                }"
                :on-remove="handleRemoveCerticatesDY"
                :before-upload="beforeImgUplod"
                :http-request="handleSuccessCerticatesDY"
                :file-list="item.value"
                accept=".JPG,.png,.GIF"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div class="action">
            <el-button
              type="primary"
              size="small"
              @click="appltSettingSave('dyCategories')"
              >添加</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup apply-form"
      :class="{
        show: isShowApplyPrivacy,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>申请地理位置接口</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowApplyPrivacy = false"
          />
        </div>
        <div class="popup-container">
          <el-form
            :model="aliSubMsgForm"
            :rules="aliSubMsgRules"
            ref="aliSubMsgForm"
            label-width="128px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="申请理由：" prop="content">
              <el-input
                type="textarea"
                maxlength="300"
                show-word-limit
                clearable
                placeholder="请输入申请理由"
                v-model="applyForm.content"
                :rows="5"
              ></el-input>
            </el-form-item>
            <el-form-item label="辅助网页(选填)：">
              <div>
                <span class="tips">可上传官网链接协助审核</span>
              </div>
              <div
                class="input-row"
                v-for="(item, index) in applyForm.url_list"
                :key="index"
              >
                <el-input
                  size="small"
                  type="text"
                  placeholder="请输入网页链接"
                  v-model="item.url"
                ></el-input>
                <i class="el-icon-delete-solid" @click="delApplyUrl(index)"></i>
              </div>
              <el-button
                v-if="applyForm.url_list.length < 3"
                type="primary"
                size="small"
                @click="addApplyUrl"
                >添加</el-button
              >
            </el-form-item>
            <el-form-item label="辅助图片(选填)：">
              <span class="tips"
                >可上传小程序截图，最多上传10张图片。图片支持jpg、jpeg、bmp、gif或png格式，图片大小不超过5M。</span
              >
              <el-upload
                ref="upload"
                :multiple="true"
                action="/YmUpload_image"
                list-type="picture-card"
                :on-remove="handleRemoveApplyPic"
                :before-upload="beforeImgUplod"
                :http-request="handleSuccessApplyPic"
                :file-list="applyForm.pic_list"
                accept=".JPG,.png,.GIF"
                :limit="10"
                :class="{
                  hide: applyForm.pic_list.length >= 10,
                }"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="辅助视频(选填)：">
              <span class="tips">填写视频的链接 ，最多支持1个</span>
              <el-upload
                ref="upload"
                :multiple="true"
                action="/YmUpload_videoFile"
                :on-remove="handleRemoveVideo"
                :http-request="handleSuccessVideo"
                :file-list="applyForm.video_list"
                accept="video/*"
                :limit="1"
                :class="{
                  hide: applyForm.video_list.length,
                }"
              >
                <el-button
                  v-show="!applyForm.video_list.length"
                  size="small"
                  type="primary"
                  >点击上传</el-button
                >
              </el-upload>
            </el-form-item>
          </el-form>
          <div class="action">
            <el-button type="primary" @click="wxMiniAppApplyPrivacy">提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="popup apply-form"
      :class="{
        show: isShowMerchantInfoPopup,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>提交进件信息</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowMerchantInfoPopup = false"
          />
        </div>
        <div class="popup-container">
          <el-form
            :model="merchantInfoForm"
            :rules="merchantInfoRules"
            ref="merchantInfoForm"
            label-width="158px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="抖音小程序token：" prop="payToken">
              <el-input
                type="text"
                placeholder="请输入抖音小程序token"
                v-model="merchantInfoForm.payToken"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="action">
            <el-button type="primary" @click="putPayTokenDY">提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  updateMiniAppInfo,
  updateMiniAppInfoAlipay,
  updateDYMiniAppInfo,
  findAuditStatus,
  submitAudit,
  submitAuditAlipay,
  submitAuditDY,
  undocodeaudit,
  undocodeauditAlipay,
  undocodeauditDY,
  bindtester,
  unbindtester,
  membersQuery,
  bindtesterAlipay,
  unbindtesterAlipay,
  getMiniAppInfoAlipay,
  getDYMiniAppInfo,
  getWxCode,
  setIslive,
  createPayUrl,
  miniAppProduceRelease,
  miniAppProduceReleaseAlipay,
  miniAppProduceReleaseDY,
  getMiniAppSubscribeMessageTemplateList,
  modifyMiniAppSubscribeMessage,
  addPublishQrCodeJump,
  addQrCodeJumpPay,
  addQrCodeJumpIndex,
  addBindOpenLink,
  addBindQrCode,
  uploadImg,
  getMiniAppAllCategories,
  modifyMiniAppInfo,
  getMiniAppAllCategoriesDY,
  addMiniAppAllCategoriesDY,
  wxMiniAppAddCategories,
  wxMiniAppGetPrivacy,
  wxMiniAppApplyPrivacy,
  uploadVideo,
  getMerchantStatusDY,
  putPayTokenDY,
  getAppMerchantDY,
  deleteMiniAppSubscribeMessage,
} from "@/api";
import { commonFuc } from "@/mixins/commonFuc";
import { mapState, mapActions } from "vuex";
import qrcode from "@xkeshi/vue-qrcode";
import QRCode from "qrcode";
import html2canvas from "html2canvas";

let miniAppPlatform = {
  wx: 1,
  TINYAPP: 2,
  IOTAPP: 3,
};

export default {
  mixins: [commonFuc],
  data() {
    return {
      auditStatus: null,
      weixinString: "",
      alipayAccountList: [],
      selAlipayAccount: "",
      QueryDetail: "",
      switchLive: false,
      dialogVisible: false,
      messageList: [],
      checkedMessage: "",
      onOfMessageList: [],
      publishQrCode: "",
      publishPayQrCode: "",
      aliSubMsgPop: false,
      aliSubMsgRules: {
        templateId: [
          {
            required: true,
            message: "请输入外部平台模板id",
            trigger: "blur",
          },
        ],
      },
      aliSubMsgForm: {
        templateNo: "",
        templateId: "",
        templateName: "",
        templateId: "",
      },
      isModify: false,
      isLoading: false,
      isShowBindQrcode: false,
      openLink: false,
      isBindQrCode: false,
      appltReleaseLoading: false,
      headImg: [],
      isShowNicSetting: false,
      isShowHImgSetting: false,
      wxNickName: "",
      isShowSignatureSetting: false,
      signature: "",
      isShowWxCategoriesSetting: false,
      wxCategoriesList: [],
      wxFCate: "",
      wxSCate: "",
      wxCategoriesForm: {
        first: "",
        second: "",
        certicates: [],
      },
      wxCategoriesRules: {
        first: [
          {
            required: true,
            message: "请选择一级类目",
            trigger: "blur",
          },
        ],
        second: [
          {
            required: true,
            message: "请选择二级类目",
            trigger: "blur",
          },
        ],
      },
      aliCategoryList: [],
      aliFCate: "",
      aliSCate: "",
      aliTCate: "",
      aliViceFCate: "",
      aliViceSCate: "",
      aliViceTCate: "",
      aliCategoriesForm: {
        categories: "",
        viceCategories: "",
        miniCategoryIds: "",
        miniViceCategoryIds: "",
        needLicense: false,
        needOutDoorPic: false,
        needSpecialLicense: false,
        outDoorPic: "",
        businessName: "",
        businessRegistNumber: "",
        licensePics: "",
        licenseValidDate: "",
        specialLicensePics: "",
      },
      outDoorPic: [],
      licensePics: [],
      specialLicensePics: [],
      aliCategoriesRules: {
        categories: [
          {
            required: true,
            message: "请选择主营类目",
            trigger: "blur",
          },
        ],
        viceCategories: [
          {
            required: true,
            message: "请选择辅营类目",
            trigger: "blur",
          },
        ],
        outDoorPic: [
          {
            required: true,
            message: "请上传门头照",
            trigger: "blur",
          },
        ],
        businessName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        businessRegistNumber: [
          {
            required: true,
            message: "请输入注册号",
            trigger: "blur",
          },
        ],
        licensePics: [
          {
            required: true,
            message: "请上传营业执照图片",
            trigger: "blur",
          },
        ],
        licenseValidDate: [
          {
            required: true,
            message: "请输入营业执照到期时间",
            trigger: "blur",
          },
        ],
        specialLicensePics: [
          {
            required: true,
            message: "请上传特殊资质图片",
            trigger: "blur",
          },
        ],
      },
      aliCateType: "",
      isShowAliCategoriesSetting: false,
      isCateInit: false,
      isShowApplyPrivacy: false,
      stausObj: {
        1: "待申请开通",
        2: "无权限",
        3: "申请中",
        4: "申请失败",
        5: "已开通",
      },
      wxGetLocationStatus: 1,
      wxOnLocationChangeStatus: 1,
      wxGetLocationFailReason: "",
      wxOnLocationChangeFailReason: "",
      applyType: "wx.getLocation",
      applyForm: {
        content: "",
        url_list: [],
        pic_list: [],
        video_list: [],
      },
      isShowDYCategoriesSetting: false,
      dyCategoryList: [],
      dyCategory: [],
      dyCategoryCertification: [],
      merchantStatusDY: true,
      merchantStatusDYURL: "",
      isShowMerchantInfoPopup: false,
      merchantInfoForm: {
        payToken: "",
        merchantId: "",
      },
      merchantInfoRules: {
        payToken: [
          {
            required: true,
            message: "请输入抖音小程序token",
            trigger: "blur",
          },
        ],
        merchantId: [
          {
            required: true,
            message: "请输入抖音商户号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      applitInfo: (state) => state.applitInfo,
      appltType: (state) => state.appltType,
      isOwn: (state) => state.isOwn,
    }),
  },
  components: {
    qrcode,
  },
  watch: {
    applitInfo: {
      handler: function (val) {
        if (val.state == 2 && this.appltType == "wx") {
          this.findAuditStatus();
        }
        this.getPageData();
        this.$forceUpdate();
      },
      deep: true,
    },
    appltType() {
      // this.getPageData();
    },
    switchLive: function (val) {
      localStorage.switchLive = val;
    },
    wxFCate(val) {
      if (val) {
        this.wxSCate = "";
        this.wxCategoriesForm.first = this.wxCategoriesList[val].id;
      }
    },
    wxSCate(val) {
      if (val) {
        this.wxCategoriesForm.second = this.wxCategoriesList[val].id;
        if (
          this.wxCategoriesList[val].sensitive_type == 1 &&
          this.wxCategoriesList[val].qualify.exter_list.length
        ) {
          this.wxCategoriesForm.certicates = [];
          let list = [];
          this.wxCategoriesList[val].qualify.exter_list.forEach((exter) => {
            exter.inner_list.forEach((inner) => {
              list.push({
                key: inner.name,
                value: [],
              });
            });
          });
          this.wxCategoriesForm.certicates = list;
          console.log(this.wxCategoriesForm.certicates);
        }
      } else {
        this.wxCategoriesForm.second = "";
      }
    },
    aliFCate(val) {
      if (!this.isCateInit) return;
      console.log(this.isCateInit);
      this.aliTCate = "";
      this.aliSCate = "";
      let curentCate = this.aliCategoryList[val];
      if (val !== "" && !curentCate.hasChild) {
        this.aliCategoriesForm.categories = curentCate.categoryName;
        this.aliCategoriesForm.miniCategoryIds = curentCate.categoryId;
        this.aliCategoriesForm.needLicense = curentCate.needLicense;
        this.aliCategoriesForm.needOutDoorPic = curentCate.needOutDoorPic;
        this.aliCategoriesForm.needSpecialLicense = curentCate.needSpecialLicense;
      } else {
        this.aliCategoriesForm.categories = "";
        this.aliCategoriesForm.miniCategoryIds = "";
        this.aliCategoriesForm.needLicense = false;
        this.aliCategoriesForm.needOutDoorPic = false;
        this.aliCategoriesForm.needSpecialLicense = false;
      }
    },
    aliSCate(val) {
      if (!this.isCateInit) return;
      this.aliTCate = "";
      let curentCate = this.aliCategoryList[val];
      if (val !== "" && !curentCate.hasChild) {
        let FCate = this.aliCategoryList[this.aliFCate];
        this.aliCategoriesForm.categories = `${FCate.categoryName}_${curentCate.categoryName}`;
        this.aliCategoriesForm.miniCategoryIds = `${FCate.categoryId}_${curentCate.categoryId}`;
        this.aliCategoriesForm.needLicense = curentCate.needLicense;
        this.aliCategoriesForm.needOutDoorPic = curentCate.needOutDoorPic;
        this.aliCategoriesForm.needSpecialLicense = curentCate.needSpecialLicense;
      } else {
        this.aliCategoriesForm.categories = "";
        this.aliCategoriesForm.miniCategoryIds = "";
        this.aliCategoriesForm.needLicense = false;
        this.aliCategoriesForm.needOutDoorPic = false;
        this.aliCategoriesForm.needSpecialLicense = false;
      }
    },
    aliTCate(val) {
      if (!this.isCateInit) return;
      let curentCate = this.aliCategoryList[val];
      if (val !== "" && !curentCate.hasChild) {
        let FCate = this.aliCategoryList[this.aliFCate];
        let SCate = this.aliCategoryList[this.aliSCate];
        this.aliCategoriesForm.categories = `${FCate.categoryName}_${SCate.categoryName}_${curentCate.categoryName}`;
        this.aliCategoriesForm.miniCategoryIds = `${FCate.categoryId}_${SCate.categoryId}_${curentCate.categoryId}`;
        this.aliCategoriesForm.needLicense = curentCate.needLicense;
        this.aliCategoriesForm.needOutDoorPic = curentCate.needOutDoorPic;
        this.aliCategoriesForm.needSpecialLicense = curentCate.needSpecialLicense;
      } else {
        this.aliCategoriesForm.categories = "";
        this.aliCategoriesForm.miniCategoryIds = "";
        this.aliCategoriesForm.needLicense = false;
        this.aliCategoriesForm.needOutDoorPic = false;
        this.aliCategoriesForm.needSpecialLicense = false;
      }
    },
    aliViceFCate(val) {
      if (!this.isCateInit) return;
      this.aliViceTCate = "";
      this.aliViceSCate = "";
      let curentCate = this.aliCategoryList[val];
      if (val !== "" && !curentCate.hasChild) {
        this.aliCategoriesForm.viceCategories = curentCate.categoryName;
        this.aliCategoriesForm.miniViceCategoryIds = curentCate.categoryId;
        this.aliCategoriesForm.needLicense = curentCate.needLicense;
        this.aliCategoriesForm.needOutDoorPic = curentCate.needOutDoorPic;
        this.aliCategoriesForm.needSpecialLicense = curentCate.needSpecialLicense;
      } else {
        this.aliCategoriesForm.viceCategories = "";
        this.aliCategoriesForm.miniViceCategoryIds = "";
        this.aliCategoriesForm.needLicense = false;
        this.aliCategoriesForm.needOutDoorPic = false;
        this.aliCategoriesForm.needSpecialLicense = false;
      }
    },
    aliViceSCate(val) {
      if (!this.isCateInit) return;
      this.aliViceTCate = "";
      let curentCate = this.aliCategoryList[val];
      if (val !== "" && !curentCate.hasChild) {
        let FCate = this.aliCategoryList[this.aliViceFCate];
        this.aliCategoriesForm.viceCategories = `${FCate.categoryName}_${curentCate.categoryName}`;
        this.aliCategoriesForm.miniViceCategoryIds = `${FCate.categoryId}_${curentCate.categoryId}`;
        this.aliCategoriesForm.needLicense = curentCate.needLicense;
        this.aliCategoriesForm.needOutDoorPic = curentCate.needOutDoorPic;
        this.aliCategoriesForm.needSpecialLicense = curentCate.needSpecialLicense;
      } else {
        this.aliCategoriesForm.viceCategories = "";
        this.aliCategoriesForm.miniViceCategoryIds = "";
        this.aliCategoriesForm.needLicense = false;
        this.aliCategoriesForm.needOutDoorPic = false;
        this.aliCategoriesForm.needSpecialLicense = false;
      }
    },
    aliViceTCate(val) {
      if (!this.isCateInit) return;
      let curentCate = this.aliCategoryList[val];
      if (val !== "" && !curentCate.hasChild) {
        let FCate = this.aliCategoryList[this.aliViceFCate];
        let SCate = this.aliCategoryList[this.aliViceSCate];
        this.aliCategoriesForm.viceCategories = `${FCate.categoryName}_${SCate.categoryName}_${curentCate.categoryName}`;
        this.aliCategoriesForm.miniViceCategoryIds = `${FCate.categoryId}_${SCate.categoryId}_${curentCate.categoryId}`;
        this.aliCategoriesForm.needLicense = curentCate.needLicense;
        this.aliCategoriesForm.needOutDoorPic = curentCate.needOutDoorPic;
        this.aliCategoriesForm.needSpecialLicense = curentCate.needSpecialLicense;
      } else {
        this.aliCategoriesForm.viceCategories = "";
        this.aliCategoriesForm.miniViceCategoryIds = "";
        this.aliCategoriesForm.needLicense = false;
        this.aliCategoriesForm.needOutDoorPic = false;
        this.aliCategoriesForm.needSpecialLicense = false;
      }
    },
    dyCategory(val) {
      if (val.length) {
        let findex = this.dyCategoryList.findIndex((item) => item.value == val[0]);
        if (findex != -1) {
          let sindex = this.dyCategoryList[findex].children.findIndex(
            (item) => item.value == val[1]
          );
          if (sindex != -1) {
            let lindex = this.dyCategoryList[findex].children[sindex].children.findIndex(
              (item) => item.value == val[2]
            );
            if (lindex != -1) {
              let list = [];
              this.dyCategoryList[findex].children[sindex].children[
                lindex
              ].certification.list.forEach((cert) => {
                if (
                  list.findIndex((lval) => {
                    return lval.id == cert.id;
                  }) == -1
                ) {
                  list.push({
                    key: cert.name,
                    id: cert.id,
                    tipsText: "",
                    value: [],
                  });
                }
              });
              let relationList = [];
              this.dyCategoryList[findex].children[sindex].children[
                lindex
              ].certification.relation.forEach((rel) => {
                if (rel.indexOf("|") != -1) {
                  relationList.push(rel);
                }
              });
              relationList.forEach((rel) => {
                let relArr = rel.split("|");
                list.forEach((lval, lindex) => {
                  if (relArr.includes(lval.id)) {
                    console.log(rel);
                    list[lindex].tipsText = `${rel
                      .replace(/\d+/g, (reval) => {
                        let lindex = list.findIndex((val) => {
                          return val.id == reval;
                        });
                        if (lindex != -1) {
                          return list[lindex].key;
                        }
                      })
                      .replace(/\|/g, "或")
                      .replace(/\&/g, "和")}，${rel.split("|").length}选1`;
                  }
                });
              });
              this.dyCategoryCertification = list;
            }
          }
        }
      }
    },
  },
  mounted() {
    this.getPageData();
    this.wxMiniAppGetPrivacy();
    this.switchLive = localStorage.switchLive == "true" ? true : false;
  },
  methods: {
    ...mapActions(["updateAppltInfo"]),
    getPageData() {
      if (this.isLoading) return;
      if (this.applitInfo) {
        this.isLoading = true;
        this.getMiniAppAllCategories();
      }
      this.publishQrCode = ``;
      this.publishPayQrCode = ``;
      console.log(this.applitInfo);
      this.auditStatus = {
        status:
          this.applitInfo && !this.applitInfo.state && isNaN(this.applitInfo.state)
            ? -1
            : this.applitInfo && this.applitInfo.state,
      };
      if (this.applitInfo && this.applitInfo.headImg) {
        this.headImg = [{ name: "", url: this.applitInfo.headImg }];
      }
      if (this.applitInfo && this.applitInfo.outDoorPic) {
        this.aliCategoriesForm.outDoorPic = this.applitInfo.outDoorPic;
        let img = this.applitInfo.outDoorPic.split(",");
        img.forEach((val) => {
          this.outDoorPic = [{ name: "outDoorPic", url: val }];
        });
      }
      if (this.applitInfo && this.applitInfo.licensePics) {
        this.aliCategoriesForm.licensePics = this.applitInfo.licensePics;
        let img = this.applitInfo.licensePics.split(",");
        img.forEach((val) => {
          this.licensePics = [{ name: "licensePics" + +new Date(), url: val }];
        });
      }
      if (this.applitInfo && this.applitInfo.specialLicensePics) {
        this.aliCategoriesForm.specialLicensePics = this.applitInfo.specialLicensePics;
        let img = this.applitInfo.specialLicensePics.split(",");
        img.forEach((val) => {
          this.specialLicensePics = [
            { name: "specialLicensePics" + +new Date(), url: val },
          ];
        });
      }
      if (this.appltReleaseLoading) {
        this.findAuditStatus();
      }
      if (this.auditStatus.status == 2 && this.appltType == "wx") {
        this.findAuditStatus();
      }
      if (this.auditStatus.status == 1) {
        this.auditStatus.reason = this.applitInfo.stateMsg;
      }
      if (this.appltType == "TINYAPP" || this.appltType == "IOTAPP") {
        this.membersQuery();
      }
      if (this.applitInfo && this.applitInfo.isBindQrCode) {
        // this.publishQrCode = `https://qr.wei.gg/qrcode/mid${
        //   localStorage.userId
        // }/shopid${localStorage.shopId}/uniform?mtype=1`;
        // this.publishPayQrCode = `https://qr.wei.gg/qrcode/mid${
        //   localStorage.userId
        // }/shopid${localStorage.shopId}/uniform?mtype=2`;
        // this.addQrCodeJumpIndex();
        // this.addQrCodeJumpPay();
        this.isShowBindQrcode = true;
      } else {
        this.isShowBindQrcode = false;
      }
      this.openLink = this.applitInfo && this.applitInfo.isBindOpenLink == 1;
      this.isBindQrCode = this.applitInfo && this.applitInfo.isBindQrCode == 1;
      // this.getPayCode();
      this.weixinString = "";
      if (miniAppPlatform[this.appltType]) {
        this.getMiniAppSubscribeMessageTemplateListOfOn();
        this.getMiniAppSubscribeMessageTemplateListOfUn();
      }
      if (this.appltType == "dy") {
        this.getMerchantStatusDY();
      }
      this.isLoading = false;
    },
    putPayTokenDY() {
      this.$refs.merchantInfoForm.validate((valid) => {
        if (valid) {
          putPayTokenDY(this.merchantInfoForm).then((res) => {
            if (res.code == 1) {
              this.$notify.success("提交成功");
              this.isShowMerchantInfoPopup = false;
            } else {
              this.$notify.error(res.msg);
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    getMerchantStatusDY() {
      getMerchantStatusDY().then((res) => {
        if (res.code == 1) {
          // this.publishQrCode = res.data.url;
          if (res.data.status == "success") {
            this.merchantStatusDY = true;
          } else {
            this.merchantStatusDY = false;
            this.getAppMerchantDY();
          }
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    getAppMerchantDY() {
      getAppMerchantDY().then((res) => {
        if (res.code == 1) {
          this.merchantStatusDYURL = res.data.app_merchant_url;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    openMerchantStatusDYURL() {
      window.open(this.merchantStatusDYURL);
    },
    addQrCodeJumpIndex() {
      addQrCodeJumpIndex({
        miniAppPlatform: this.appltType == "wx" ? 1 : 2,
      }).then((res) => {
        if (res.code == 1) {
          this.publishQrCode = res.data.url;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    addQrCodeJumpPay() {
      addQrCodeJumpPay({
        miniAppPlatform: this.appltType == "wx" ? 1 : 2,
      }).then((res) => {
        if (res.code == 1) {
          this.publishPayQrCode = res.data.url;
        }
      });
    },
    findAuditStatus() {
      if (this.appltType == "wx") {
        findAuditStatus().then((res) => {
          if (res.code == 1) {
            this.auditStatus = res.data;
            if (this.appltReleaseLoading) {
              this.appltReleaseLoading = false;
            }
          }
        });
      } else if (this.appltType == "dy") {
        getDYMiniAppInfo().then((res) => {
          if (res.code == 1) {
            if (res.data.categories) {
              res.data.categories = JSON.parse(res.data.categories);
            }
            this.updateAppltInfo(res.data);
            this.auditStatus = {
              status: isNaN(res.data.state) ? -1 : res.data.state,
            };
            if (this.auditStatus.status == 1) {
              this.auditStatus.reason = res.data.stateMsg;
            }
            if (this.appltReleaseLoading) {
              this.appltReleaseLoading = false;
            }
            this.getPageData();
          }
        });
      } else {
        getMiniAppInfoAlipay({
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.updateAppltInfo(res.data);
            this.auditStatus = {
              status: isNaN(res.data.state) ? -1 : res.data.state,
            };
            if (this.auditStatus.status == 1) {
              this.auditStatus.reason = res.data.stateMsg;
            }
            if (this.appltReleaseLoading) {
              this.appltReleaseLoading = false;
            }
            this.getPageData();
          }
        });
      }
    },
    wxMiniAppGetPrivacy() {
      wxMiniAppGetPrivacy({
        shopId: localStorage.shopId,
      }).then((res) => {
        if (res.data.errcode == 0) {
          res.data.interface_list.forEach((val) => {
            if (val.api_name == "wx.getLocation") {
              this.wxGetLocationStatus = val.status;
              if (val.fail_reason) {
                this.wxGetLocationFailReason = val.fail_reason;
              }
            }
            if (val.api_name == "wx.onLocationChange") {
              this.wxOnLocationChangeStatus = val.status;
              if (val.fail_reason) {
                this.wxOnLocationChangeFailReason = val.fail_reason;
              }
            }
          });
        }
      });
    },
    wxMiniAppApplyPrivacy() {
      if (!this.applyForm.content) {
        return this.$notify.error("请输入申请理由");
      }
      let urlList = [];
      let picList = [];
      let videoList = [];
      this.applyForm.url_list.forEach((val) => {
        if (val.url) {
          urlList.push(val.url);
        }
      });
      this.applyForm.pic_list.forEach((val) => {
        if (val.url) {
          picList.push(val.url);
        }
      });
      this.applyForm.video_list.forEach((val) => {
        if (val.url) {
          videoList.push(val.url);
        }
      });
      wxMiniAppApplyPrivacy({
        miniAppPlatform: 1,
        shopId: localStorage.shopId,
        api_name: this.applyType,
        content: this.applyForm.content,
        url_list: urlList.join(","),
        pic_list: picList.join(","),
        video_list: videoList.join(","),
      }).then((res) => {
        if (res.data.errcode == 0) {
          this.$notify.success("提交成功");
          this.isShowApplyPrivacy = false;
          this.wxMiniAppGetPrivacy();
        } else {
          this.$notify.error(res.data.errmsg);
        }
      });
    },
    liveChange(val) {
      console.log(val);
      var isLive;
      if (val == true) {
        isLive = 1;
      } else {
        isLive = 0;
      }
      setIslive({
        isLive: isLive || 0,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success(res.msg);
          }
        })
        .catch((error) => {
          this.$message.success(error.msg);
        });
    },
    getMiniAppSubscribeMessageTemplateListOfUn() {
      getMiniAppSubscribeMessageTemplateList({
        miniAppPlatform: miniAppPlatform[this.appltType],
        addStatus: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.messageList = res.data;
        } else if (res.code == -1) {
          this.messageList = [];
        }
        this.isLoading = false;
      });
    },
    getMiniAppSubscribeMessageTemplateListOfOn() {
      getMiniAppSubscribeMessageTemplateList({
        miniAppPlatform: miniAppPlatform[this.appltType],
        addStatus: 2,
      }).then((res) => {
        if (res.code == 1) {
          this.onOfMessageList = res.data;
        } else {
          this.onOfMessageList = [];
        }
      });
    },
    modifyMiniAppSubscribeMessage() {
      modifyMiniAppSubscribeMessage({
        miniAppPlatform: miniAppPlatform[this.appltType],
        wxSubscribeMessageTemplateId: this.checkedMessage,
        templateId: this.appltType != "wx" ? this.aliSubMsgForm.templateId : "",
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "添加成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    membersQuery() {
      membersQuery({
        role: "EXPERIENCER",
        applicationType: this.appltType,
      }).then((res) => {
        if (res.code == 1) {
          this.alipayAccountList = res.data;
        } else {
          // this.$notify({
          //   title: "提示",
          //   message: res.msg,
          //   type: "error",
          //   duration: 1000,
          // });
          this.alipayAccountList = [];
        }
      });
    },
    submitAudit() {
      if (this.appltType == "wx") {
        submitAudit().then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.findAuditStatus();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else if (this.appltType == "dy") {
        submitAuditDY().then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.findAuditStatus();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        submitAuditAlipay({
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "提交成功",
              type: "success",
              duration: 1000,
            });
            this.findAuditStatus();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      }
    },
    bindtester() {
      if (!this.weixinString) {
        return this.$notify({
          title: "提示",
          message: "请输入体验账号",
          type: "error",
          duration: 1000,
        });
      }
      if (this.appltType == "wx") {
        bindtester({
          weixinString: this.weixinString,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "绑定成功",
              type: "success",
              duration: 1000,
            });
            this.weixinString = "";
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        bindtesterAlipay({
          logonId: this.weixinString,
          role: "EXPERIENCER",
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "绑定成功",
              type: "success",
              duration: 1000,
            });
            this.weixinString = "";
            this.membersQuery();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      }
    },
    unbindtester() {
      if (!this.weixinString && this.appltType == "wx") {
        return this.$notify({
          title: "提示",
          message: "请输入要解绑的体验账号",
          type: "error",
          duration: 1000,
        });
      }
      if (
        (!this.selAlipayAccount && this.appltType == "TINYAPP") ||
        (!this.selAlipayAccount && this.appltType == "IOTAPP")
      ) {
        return this.$notify({
          title: "提示",
          message: "请选择要解绑的体验账号",
          type: "error",
          duration: 1000,
        });
      }
      if (this.appltType == "wx") {
        unbindtester({
          weixinString: this.weixinString,
          type: 0,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "解绑成功",
              type: "success",
              duration: 1000,
            });
            this.weixinString = "";
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        unbindtesterAlipay({
          aliUserId: this.selAlipayAccount,
          role: "EXPERIENCER",
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "解绑成功",
              type: "success",
              duration: 1000,
            });
            this.selAlipayAccount = "";
            this.membersQuery();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      }
    },
    deleteSubMsg(id) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteMiniAppSubscribeMessage({
            miniAppPlatform: miniAppPlatform[this.appltType],
            wxSubscribeMessageTemplateId: id,
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "删除成功",
                type: "success",
                duration: 1000,
              });
              this.getPageData();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 1000,
              });
            }
          });
        })
        .catch(() => {});
    },
    undocodeaudit() {
      this.$confirm("撤回操作一天只能1次，当月10次，确认撤回吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.appltType == "wx") {
            undocodeaudit().then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "撤销成功",
                  type: "success",
                  duration: 1000,
                });
                this.findAuditStatus();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 1000,
                });
              }
            });
          } else if (this.appltType == "dy") {
            undocodeauditDY().then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "撤销成功",
                  type: "success",
                  duration: 1000,
                });
                this.findAuditStatus();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 1000,
                });
              }
            });
          } else {
            undocodeauditAlipay({
              applicationType: this.appltType,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "撤销成功",
                  type: "success",
                  duration: 1000,
                });
                this.findAuditStatus();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 1000,
                });
              }
            });
          }
        })
        .catch(() => {});
    },
    updateMiniAppInfo() {
      if (this.appltType == "wx") {
        updateMiniAppInfo().then((res) => {
          if (res.code == 1) {
            res.data.categories = JSON.parse(res.data.categories);
            this.updateAppltInfo(res.data);
            this.getPageData();
            this.$notify({
              title: "提示",
              message: "刷新成功",
              type: "success",
              duration: 1000,
            });
          }
        });
      } else if (this.appltType == "dy") {
        updateDYMiniAppInfo().then((res) => {
          if (res.code == 1) {
            if (res.data.categories) {
              res.data.categories = JSON.parse(res.data.categories);
            }
            if (res.data.authorizerAppId) {
              this.updateAppltInfo(res.data);
            } else {
              this.updateAppltInfo(null);
            }
            this.getPageData();
            this.$notify({
              title: "提示",
              message: "刷新成功",
              type: "success",
              duration: 1000,
            });
          }
        });
      } else {
        updateMiniAppInfoAlipay({
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.updateAppltInfo(res.data);
            this.getPageData();
            this.$notify({
              title: "提示",
              message: "刷新成功",
              type: "success",
              duration: 1000,
            });
          }
        });
      }
    },
    getPayCode(e) {
      console.log(e);
      if (this.appltType == "wx") {
        getWxCode({}).then((res) => {
          if (res.code == 1) {
            this.QueryDetail = res.data.payUrl;
          } else {
            this.QueryDetail = "";
            if (e) {
              this.$message.error(res.msg);
            }
          }
        });
      } else {
        createPayUrl({}).then((res) => {
          if (res.code == 1) {
            this.QueryDetail = res.data.payUrl;
          } else {
            this.QueryDetail = "";
            if (e) {
              this.$message.error(res.msg);
            }
          }
        });
      }
    },
    downQrcodeUrl(url) {
      let image = new Image();
      image.setAttribute("crossOrigin", "Anonymous");
      //创建canvas DOM对象,并设置其宽高和图片一样
      let canvas = document.createElement("canvas");
      image.onload = function () {
        canvas.width = image.width;
        canvas.height = image.height;
        //坐标(0,0)表示从此处开始绘制,相当于偏移
        canvas.getContext("2d").drawImage(image, 0, 0);

        let dataURL = canvas.toDataURL("image/png");
        let a = document.createElement("a"); // 创建一个a节点插入的document
        let event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = "qrcode.png"; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      };
      image.src = url.replace("https://img02.163.gg", location.origin + "/img02.163.gg");
      console.log(image);
    },
    miniAppProduceRelease() {
      this.appltReleaseLoading = true;
      if (this.appltType == "wx") {
        miniAppProduceRelease().then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发布成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
            this.appltReleaseLoading = false;
          }
        });
      } else if (this.appltType == "dy") {
        miniAppProduceReleaseDY().then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发布成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
            this.appltReleaseLoading = false;
          }
        });
      } else {
        miniAppProduceReleaseAlipay({
          applicationType: this.appltType,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发布成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
            this.appltReleaseLoading = false;
          }
        });
      }
    },
    downPayCode() {
      let canvas = document.getElementById("paycode");
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = "paycode.png"; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
    addPublishQrCodeJump() {
      addPublishQrCodeJump({
        miniAppPlatform: this.appltType == "wx" ? 1 : 2,
      }).then((res) => {
        if (res.code == 1) {
          // this.publishQrCode = `https://qr.wei.gg/qrcode/mid${
          //   localStorage.userId
          // }/shopid${localStorage.shopId}/uniform?mtype=1`;
          // this.publishPayQrCode = `https://qr.wei.gg/qrcode/mid${
          //   localStorage.userId
          // }/shopid${localStorage.shopId}/uniform?mtype=2`;
          this.addQrCodeJumpIndex();
          this.addQrCodeJumpPay();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.modifyMiniAppSubscribeMessage();
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    editSubMsg(item, type = "add") {
      this.aliSubMsgForm.templateNo = item.templateNo;
      this.checkedMessage = item.id;
      this.aliSubMsgForm.templateItem = item.templateItem;
      this.aliSubMsgForm.templateName = item.templateName;
      if (type == "modify") {
        this.aliSubMsgForm.templateId = item.templateId;
        this.isModify = true;
      } else {
        this.isModify = false;
      }
      this.aliSubMsgPop = true;
    },
    openLinkChange() {
      addBindOpenLink({
        miniAppPlatform: miniAppPlatform[this.appltType],
        isBindOpenLink: !this.openLink ? 1 : 0,
      }).then((res) => {
        if (res.code == 1) {
          this.openLink = !this.openLink;
          this.applitInfo.isBindOpenLink = this.openLink ? 1 : 0;
        }
      });
    },
    addBindQrCode() {
      addBindQrCode({
        miniAppPlatform: miniAppPlatform[this.appltType],
        isBindQrCode: !this.isBindQrCode ? 1 : 0,
      }).then((res) => {
        if (res.code == 1) {
          this.isBindQrCode = !this.isBindQrCode;
          this.applitInfo.isBindQrCode = this.isBindQrCode ? 1 : 0;
        }
      });
    },
    handleSuccessImg(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.headImg = [{ name: "", url: res.data.url }];
        }
      });
    },
    handleSuccessApplyPic(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadImg(imgUploadForm).then((resp) => {
        if (resp.code == 1) {
          this.applyForm.pic_list.push({ name: "", url: resp.data.url });
          console.log(this.applyForm);
        }
      });
    },
    handleSuccessCerticates(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadImg(imgUploadForm).then((resp) => {
        if (resp.code == 1) {
          let cIndex = this.wxCategoriesForm.certicates.findIndex((v) => {
            return v.key == res.data.key;
          });
          this.wxCategoriesForm.certicates[cIndex].value = [
            { name: res.data.key, url: resp.data.url },
          ];
          console.log(this.wxCategoriesForm);
        }
      });
    },
    handleSuccessCerticatesDY(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadImg(imgUploadForm).then((resp) => {
        if (resp.code == 1) {
          let cIndex = this.dyCategoryCertification.findIndex((v) => {
            return v.key == res.data.key;
          });
          this.dyCategoryCertification[cIndex].value.push({
            name: res.data.key,
            url: resp.data.url,
          });
          console.log(this.dyCategoryCertification);
        }
      });
    },
    handleSuccessCerticatesAli(res) {
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", res.file);
      imgUploadForm.append("fileContentType", res.file.type);
      imgUploadForm.append("fileFileName", res.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadImg(imgUploadForm).then((resp) => {
        if (resp.code == 1) {
          if (res.data.key == "outDoorPic") {
            this.outDoorPic = [{ name: res.data.key, url: resp.data.url }];
            this.aliCategoriesForm.outDoorPic = resp.data.url;
          }
          if (res.data.key == "licensePics") {
            if (!this.licensePics.length) {
              this.licensePics = [
                {
                  name: res.data.key + +new Date(),
                  url: resp.data.url,
                },
              ];
            } else {
              this.licensePics.push({
                name: res.data.key + +new Date(),
                url: resp.data.url,
              });
            }
            this.aliCategoriesForm.licensePics = "";
            this.licensePics.forEach((val, index) => {
              if (index == 0) {
                this.aliCategoriesForm.licensePics = val.url;
              } else {
                this.aliCategoriesForm.licensePics += `,${val.url}`;
              }
            });
          }
          if (res.data.key == "specialLicensePics") {
            if (!this.specialLicensePics.length) {
              this.specialLicensePics = [
                {
                  name: res.data.key + +new Date(),
                  url: resp.data.url,
                },
              ];
            } else {
              this.specialLicensePics.push({
                name: res.data.key + +new Date(),
                url: resp.data.url,
              });
            }
            this.aliCategoriesForm.specialLicensePics = "";
            this.specialLicensePics.forEach((val, index) => {
              if (index == 0) {
                this.aliCategoriesForm.specialLicensePics = val.url;
              } else {
                this.aliCategoriesForm.specialLicensePics += `,${val.url}`;
              }
            });
          }
        }
      });
    },
    handleRemoveApplyPic(file) {
      let cIndex = this.applyForm.pic_list.findIndex((v) => {
        return v.rul == file.url;
      });
      this.applyForm.pic_list.splice(cIndex, 1);
    },
    handleRemoveCerticates(file) {
      let cIndex = this.wxCategoriesForm.certicates.findIndex((v) => {
        return v.key == file.name;
      });
      this.wxCategoriesForm.certicates[cIndex].value = [];
    },
    handleRemoveCerticatesDY(file) {
      let cIndex = this.dyCategoryCertification.findIndex((v) => {
        return v.key == file.name;
      });
      if (cIndex != -1) {
        let imgIndex = this.dyCategoryCertification[cIndex].value.findIndex(
          (v) => v.url == file.url
        );
        console.log(imgIndex);
        if (imgIndex != -1) {
          this.dyCategoryCertification[cIndex].value.splice(imgIndex, 1);
        }
      }
    },
    handleRemoveCerticatesAli(file) {
      console.log(file);
      if (!!~file.name.indexOf("outDoorPic")) {
        this.outDoorPic = [];
        this.aliCategoriesForm.outDoorPic = "";
        return;
      }
      if (!!~file.name.indexOf("specialLicensePics")) {
        let index = this.specialLicensePics.findIndex((val) => {
          return val.name == file.name;
        });
        this.specialLicensePics.splice(index, 1);
        this.aliCategoriesForm.specialLicensePics = "";
        this.specialLicensePics.forEach((val, index) => {
          if (index == 0) {
            this.aliCategoriesForm.specialLicensePics = val.url;
          } else {
            this.aliCategoriesForm.specialLicensePics += `,${val.url}`;
          }
        });
        return;
      }
      if (!!~file.name.indexOf("licensePics")) {
        let index = this.licensePics.findIndex((val) => {
          return val.name == file.name;
        });
        this.licensePics.splice(index, 1);
        this.aliCategoriesForm.licensePics = "";
        this.licensePics.forEach((val, index) => {
          if (index == 0) {
            this.aliCategoriesForm.licensePics = val.url;
          } else {
            this.aliCategoriesForm.licensePics += `,${val.url}`;
          }
        });
        return;
      }
    },
    handleRemoveImg() {
      this.headImg = [];
    },
    beforeImgUplod(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = types.includes(file.type);
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
      }
      if (!isLt3M) {
        this.$notify.error("上传图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    getMiniAppAllCategories() {
      if (this.appltType == "dy") {
        getMiniAppAllCategoriesDY({
          shopId: localStorage.shopId,
        }).then((res) => {
          console.log(res, JSON.parse(res.data.dy_app_categories));
          if (res.code == 1) {
            let list = [];
            JSON.parse(res.data.dy_app_categories).forEach((val) => {
              if (val.level == 1) {
                list.push({
                  value: val.id,
                  label: val.name,
                  children: [],
                });
              } else if (val.level == 2) {
                let findex = list.findIndex((item) => val.fpid == item.value);
                if (findex != -1) {
                  list[findex].children.push({
                    value: val.id,
                    label: val.name,
                    children: [],
                  });
                }
              } else if (val.level == 3) {
                let findex = list.findIndex((item) => val.fpid == item.value);
                if (findex != -1) {
                  let sindex = list[findex].children.findIndex(
                    (item) => val.spid == item.value
                  );
                  if (sindex != -1) {
                    list[findex].children[sindex].children.push({
                      value: val.id,
                      label: val.name,
                      certification: val.certification,
                    });
                  }
                }
              }
            });
            this.dyCategoryList = list;
            setTimeout(() => {
              this.isCateInit = true;
            }, 0);
          }
        });
      } else {
        getMiniAppAllCategories({
          miniAppPlatform: this.appltType == "wx" ? 1 : 2,
          shopId: localStorage.shopId,
        }).then((res) => {
          if (res.code == 1) {
            if (this.appltType == "wx") {
              this.wxCategoriesList = JSON.parse(res.data.weixin_mini_categorie_list);
            } else {
              this.aliCategoryList = JSON.parse(res.data.alipay_mini_category_list);
              if (
                this.applitInfo &&
                this.applitInfo.categories &&
                this.appltType == "TINYAPP"
              ) {
                let fminiCategoryIds = this.applitInfo.miniCategoryIds
                  ? this.applitInfo.miniCategoryIds.split(";")[0]
                  : "";
                if (fminiCategoryIds) {
                  let firstCate = fminiCategoryIds.split("_");
                  let fIndex = this.aliCategoryList.findIndex((val) => {
                    return val.categoryId == firstCate[0];
                  });
                  let sIndex = this.aliCategoryList.findIndex((val) => {
                    return val.categoryId == firstCate[1];
                  });
                  let tIndex = this.aliCategoryList.findIndex((val) => {
                    return val.categoryId == firstCate[2];
                  });
                  this.aliFCate = fIndex != -1 ? fIndex : "";
                  this.aliSCate = sIndex != -1 ? sIndex : "";
                  this.aliTCate = tIndex != -1 ? tIndex : "";
                }
                let sminiCategoryIds = this.applitInfo.miniCategoryIds
                  ? this.applitInfo.miniCategoryIds.split(";")[1]
                  : "";
                if (sminiCategoryIds) {
                  let secondtCate = sminiCategoryIds.split("_");
                  let fIndex = this.aliCategoryList.findIndex((val) => {
                    return val.categoryId == secondtCate[0];
                  });
                  let sIndex = this.aliCategoryList.findIndex((val) => {
                    return val.categoryId == secondtCate[1];
                  });
                  let tIndex = this.aliCategoryList.findIndex((val) => {
                    return val.categoryId == secondtCate[2];
                  });
                  this.aliViceFCate = fIndex != -1 ? fIndex : "";
                  this.aliViceSCate = sIndex != -1 ? sIndex : "";
                  this.aliViceTCate = tIndex != -1 ? tIndex : "";
                }
              }
            }
            setTimeout(() => {
              this.isCateInit = true;
            }, 0);
          }
        });
      }
    },
    appltSet(type) {
      if (type == "wxNic") {
        this.wxNickName = JSON.parse(JSON.stringify(this.applitInfo.nickName));
        this.isShowNicSetting = true;
      } else if (type == "wxHImg") {
        this.headImg = [{ name: "", url: this.applitInfo.headImg }];
        this.isShowHImgSetting = true;
      } else if (type == "wxSignature") {
        this.signature = JSON.parse(JSON.stringify(this.applitInfo.signature));
        this.isShowSignatureSetting = true;
      } else if (type == "wxCategories") {
        this.isShowWxCategoriesSetting = true;
      } else if (type == "aliCategories") {
        this.aliCateType = "just";
        let list = this.aliCategoryList;
        this.aliCategoriesForm.needLicense =
          (list[this.aliFCate] && list[this.aliFCate].needLicense) ||
          (list[this.aliSCate] && list[this.aliSCate].needLicense) ||
          (list[this.aliTCate] && list[this.aliTCate].needLicense);
        this.aliCategoriesForm.needOutDoorPic =
          (list[this.aliFCate] && list[this.aliFCate].needOutDoorPic) ||
          (list[this.aliSCate] && list[this.aliSCate].needOutDoorPic) ||
          (list[this.aliTCate] && list[this.aliTCate].needOutDoorPic);
        this.aliCategoriesForm.needSpecialLicense =
          (list[this.aliFCate] && list[this.aliFCate].needSpecialLicense) ||
          (list[this.aliSCate] && list[this.aliSCate].needSpecialLicense) ||
          (list[this.aliTCate] && list[this.aliTCate].needSpecialLicense);
        this.isShowAliCategoriesSetting = true;
      } else if (type == "aliViceCategories") {
        this.aliCateType = "vice";
        let list = this.aliCategoryList;
        this.aliCategoriesForm.needLicense =
          (list[this.aliViceFCate] && list[this.aliViceFCate].needLicense) ||
          (list[this.aliViceSCate] && list[this.aliViceSCate].needLicense) ||
          (list[this.aliViceTCate] && list[this.aliViceTCate].needLicense);
        this.aliCategoriesForm.needOutDoorPic =
          (list[this.aliViceFCate] && list[this.aliViceFCate].needOutDoorPic) ||
          (list[this.aliViceSCate] && list[this.aliViceSCate].needOutDoorPic) ||
          (list[this.aliViceTCate] && list[this.aliViceTCate].needOutDoorPic);
        this.aliCategoriesForm.needSpecialLicense =
          (list[this.aliViceFCate] && list[this.aliViceFCate].needSpecialLicense) ||
          (list[this.aliViceSCate] && list[this.aliViceSCate].needSpecialLicense) ||
          (list[this.aliViceTCate] && list[this.aliViceTCate].needSpecialLicense);
        this.isShowAliCategoriesSetting = true;
      } else if (type == "dyCategories") {
        this.isShowDYCategoriesSetting = true;
      }
    },
    appltSettingSave(type) {
      if (type == "wxNicSave") {
        this.isShowNicSetting = false;
        this.modifyMiniAppInfo({
          miniAppPlatform: 1,
          nickName: this.wxNickName,
        });
      } else if (type == "wxHImg") {
        this.isShowHImgSetting = false;
        if (!this.headImg.length) {
          return this.$notify({
            title: "提示",
            message: "上传图片",
            type: "warning",
            duration: 3000,
          });
        }
        this.modifyMiniAppInfo({
          miniAppPlatform: 1,
          headImg: this.headImg[0].url,
        });
      } else if (type == "wxSignatureSave") {
        this.isShowSignatureSetting = false;
        this.modifyMiniAppInfo({
          miniAppPlatform: 1,
          signature: this.signature,
        });
      } else if (type == "wxCategories") {
        this.$refs.wxCategoriesForm.validate((valid) => {
          if (valid) {
            let isUp = this.wxCategoriesForm.certicates.findIndex((v) => {
              return v.value.length;
            });
            if (isUp == -1 && this.wxCategoriesForm.certicates.length) {
              return this.$notify({
                title: "提示",
                message: `请上传所需图片`,
                type: "error",
                duration: 2000,
              });
            }
            let certicates = [];
            this.wxCategoriesForm.certicates.forEach((val) => {
              if (val.value.length) {
                certicates.push({
                  key: val.key,
                  value: val.value[0].url,
                });
              }
            });
            console.log(certicates);
            wxMiniAppAddCategories({
              miniAppPlatform: 1,
              shopId: localStorage.shopId,
              firstId: this.wxCategoriesForm.first,
              secondId: this.wxCategoriesForm.second,
              certicates: JSON.stringify(certicates),
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "添加成功",
                  type: "success",
                  duration: 1000,
                });
                this.isShowWxCategoriesSetting = false;
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 3000,
                });
              }
            });
          } else {
            this.$notify({
              title: "提示",
              message: "请完善提交内容",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        });
      } else if (type == "aliCategories") {
        this.$refs.aliCategoriesForm.validate((valid) => {
          if (valid) {
            let params = {
              miniAppPlatform: 2,
              shopId: localStorage.shopId,
              nickName: this.applitInfo.nickName,
              headImg: this.headImg[0].url,
              signature: this.applitInfo.signature,
              englishName: this.applitInfo.englishName,
              servicePhone: this.applitInfo.servicePhone,
              serviceEmail: this.applitInfo.serviceEmail,
              appDesc: this.applitInfo.appDesc,
              outDoorPic: this.aliCategoriesForm.outDoorPic,
              businessName: this.aliCategoriesForm.businessName,
              businessRegistNumber: this.aliCategoriesForm.businessRegistNumber,
              licensePics: this.aliCategoriesForm.licensePics,
              licenseValidDate: this.aliCategoriesForm.licenseValidDate,
              specialLicensePics: this.aliCategoriesForm.specialLicensePics,
              categories: `${this.aliCategoriesForm.categories}${
                this.aliCategoriesForm.viceCategories
                  ? this.aliCategoriesForm.categories
                    ? `;${this.aliCategoriesForm.viceCategories}`
                    : this.aliCategoriesForm.viceCategories
                  : ""
              }`,
              miniCategoryIds: `${this.aliCategoriesForm.miniCategoryIds}${
                this.aliCategoriesForm.miniViceCategoryIds
                  ? this.aliCategoriesForm.miniCategoryIds
                    ? `;${this.aliCategoriesForm.miniViceCategoryIds}`
                    : this.aliCategoriesForm.miniViceCategoryIds
                  : ""
              }`,
            };
            this.modifyMiniAppInfo(params);
          } else {
            this.$notify({
              title: "提示",
              message: "请完善提交内容",
              type: "error",
              duration: 2000,
            });
            return false;
          }
        });
      } else if (type == "dyAppltInfo") {
        let params = {
          miniAppPlatform: 4,
          nickName: this.applitInfo.nickName,
          signature: this.applitInfo.signature,
          headImg: this.headImg[0].url,
        };
        this.modifyMiniAppInfo(params);
      } else if (type == "dyCategories") {
        console.log(this.dyCategoryCertification, this.dyCategory);
        if (!this.dyCategory.length) {
          return this.$notify({
            title: "提示",
            message: "请选择类目",
            type: "error",
            duration: 3000,
          });
        }
        // let emptyIndex = this.dyCategoryCertification.findIndex((val) => {
        //   if (!val.value.length) {
        //     return true;
        //   }
        // });
        // if (emptyIndex != -1) {
        //   return this.$notify({
        //     title: "提示",
        //     message: `请上传${this.dyCategoryCertification[emptyIndex].key}`,
        //     type: "error",
        //     duration: 3000,
        //   });
        // }
        let categoryCertList = this.dyCategoryCertification.map((val) => {
          return {
            id: val.id,
            name: val.key,
            imgs:
              val.value.length > 1
                ? val.value.reduce((t, n) => {
                    return (t.url || t) + ";" + n.url;
                  })
                : val.value[0].url,
          };
        });
        let params = {
          category: this.dyCategory.join(","),
          categoryCert: JSON.stringify(categoryCertList),
        };
        addMiniAppAllCategoriesDY(params).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "添加成功",
              type: "success",
              duration: 1000,
            });
            this.isShowDYCategoriesSetting = false;
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      }
    },
    modifyMiniAppInfo(parmas) {
      parmas.shopId = localStorage.shopId;
      modifyMiniAppInfo(parmas).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "修改成功，等待生效中，请勿重新提交",
            type: "success",
            duration: 3000,
          });
          this.updateMiniAppInfo();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 3000,
          });
        }
      });
    },
    applyPrivacy(type) {
      this.applyType = type;
      this.applyForm = {
        content: "",
        url_list: [],
        pic_list: [],
        video_list: [],
      };
      this.isShowApplyPrivacy = true;
    },
    handleRemoveVideo() {
      this.applyForm.video_list = [];
    },
    handleSuccessVideo(res) {
      let videoUploadForm = new FormData();
      videoUploadForm.append("file", res.file);
      videoUploadForm.append("fileContentType", res.file.type);
      videoUploadForm.append("fileFileName", res.file.name);
      videoUploadForm.append("isCompre", 1);
      videoUploadForm.append("isCutImage", 1);
      this.isUpload = true;
      uploadVideo(videoUploadForm).then((resp) => {
        if (resp.code == 1) {
          this.applyForm.video_list = [{ name: res.file.name, url: resp.data.url }];
          this.isUpload = false;
        }
      });
    },
    addApplyUrl() {
      this.applyForm.url_list.push({
        url: "",
      });
    },
    delApplyUrl(index) {
      this.applyForm.url_list.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
#canvas {
  width: 60% !important;
  height: auto !important;
}
.popup {
  &.apply-form {
    .input-row {
      display: flex;
      align-items: center;
      .el-icon-delete-solid {
        font-size: 20px;
        margin-left: 20px;
        &:hover {
          color: #409eff;
        }
      }
    }
  }
  &.submsg {
    .popup-content {
      width: 500px;
    }
  }
  .text-red {
    line-height: 1.5;
    color: red;
  }
  &.cate {
    &.dy {
      .popup-content {
        width: 1000px;
      }
      p {
        font-size: 16px;
        text-align: left;
        margin: 10px 0;
      }
    }
    .popup-content {
      width: 700px;
    }
    .popup-container {
      max-height: 830px;
      overflow: auto;
    }
  }
}
.applt-page .popup-container {
  .tips {
    width: 100%;
    height: auto;
    padding: 5px;
    box-sizing: border-box;
    border: 1px solid #ff9191;
    background: #ffe6e6;
    color: #ff9191;
    margin-bottom: 10px;
    p {
      font-size: 16px;
      text-align: left;
    }
  }
}

.content-page {
  .bd {
    height: 100%;
    padding: 20px;
    .el-form-item {
      margin: 25px 0;
      .applt-set-button {
        margin-left: 10px;
      }
      .form-inline-content {
        border-bottom: 1px solid #d8d8d8;
        min-height: 40px;
        padding-bottom: 24px;
        &.flex {
          display: flex;
          .inside-content + .inside-content {
            margin-left: 50px;
          }
        }
        .flex-row-start {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
        }
        .inside-content {
          .el-tag {
            cursor: pointer;
            margin-right: 10px;
          }
          .tips {
            color: red;
          }
          &.center {
            text-align: center;
          }
          .flex-column-around {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding-left: 60px;
            box-sizing: border-box;
          }
          .scan-code-img {
            display: inline-block;
            // width: 100px;
            height: 100px;
          }
          .avatar {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            vertical-align: middle;
          }
          .el-input,
          .el-select,
          .el-textarea {
            width: 300px;
            margin-right: 10px;
          }
        }
      }
    }
  }
  .popup-container {
    .action {
      margin-top: 10px;
      display: flex;
      justify-content: center;
    }
  }
  .status {
    display: inline-block;
    margin-right: 5px;
    &.ing {
      color: #ffaa00;
    }
    &.suc {
      color: #7abd54;
    }
    &.fail {
      color: #ff4c4c;
    }
  }
}
</style>

<style lang="less">
.hide .el-upload {
  display: none;
}
.popup-container {
  &.head-img {
    .el-upload-list--picture-card .el-upload-list__item {
      transition: none;
    }
  }
  .el-select + .el-select {
    margin-left: 10px;
  }
}
</style>
